import { render, staticRenderFns } from "./BackBox.vue?vue&type=template&id=39dc61c6&"
import script from "./BackBox.vue?vue&type=script&lang=ts&"
export * from "./BackBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports